<template>
  <div class="card-box">
    <el-row type="flex" justify="start">
      <el-col>
        <div style="display:flex;align-items: center">
          <el-avatar shape="square" :src="getBungieImg(character)" />
          <div style="margin-left: 10px">
            <el-row>
              {{ bungieName }}
              <el-tag>
                {{ isLeader? "队长":"队员" }}
              </el-tag>
            </el-row>
            <el-row>
              {{ character?classMap[character.classType]:'' }}
              <span style="color: #ffeb3b ">
                {{ '✦' +light }}
              </span>

            </el-row>
          </div>
        </div>
      </el-col>
      <el-col>
        <el-row type="flex">
          <el-col v-for="metric in metrics" :key="metric.key" :span="8">
            <div>
              {{ `${metricsMap[metric.key]}完成次数:${metric.value}` }}
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { GetProfile } from '@/api/bungie-api'

export default {
  name: 'GroupMemberInfo',
  props: {
    membershipId: {
      type: String,
      default: ''
    },
    isLeader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      info: {},
      bungieName: '',
      ember: undefined,
      character: undefined,
      light: '',
      classMap: {
        0: '泰坦',
        1: '猎人',
        2: '术士'
      },
      metricsList: [
        1092085792,
        3766204132,
        1061853070,
        1428773193,
        2207849635,
        2669380142
      ],
      metricsMap: {
        1092085792: '国王的陨落',
        3766204132: '最后一愿',
        1061853070: '救赎花园',
        1428773193: '深岩墓室',
        2207849635: '玻璃拱顶',
        2669380142: '门徒誓约'
      },
      /*
    public static readonly ALL_PLATFORM = new Platform(0, 'ALL', 'All', faUsers);
public static readonly XBL_PLATFORM = new Platform(1, 'XBL', 'Xbox', faXbox);
public static readonly PSN_PLATFORM = new Platform(2, 'PSN', 'Playstation', faPlaystation);
public static readonly STEAM_PLATFORM = new Platform(3, 'STEAM', 'Steam', faSteam);
public static readonly STADIA_PLATFORM = new Platform(5, 'STADIA', 'Stadia', faGoogle);
public static readonly EPIC_PLATFORM = new Platform(6, 'EPIC', 'Epic', faWindows);
 */
      platformMap: {
        TigerXbox: 1,
        TigerPsn: 2,
        TigerSteam: 3,
        TigerBlizzard: 4,
        TigerStadia: 5,
        TigerEgs: 6,
        TigerDemon: 10
      },
      metrics: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const params = {
        components: '100,200,1100'
      }

      this.getBungieInfo(params, '3')
    },
    getBungieInfo(params, membershipType) {
      GetProfile(params, membershipType, this.membershipId).then(res => {
        const info = res['profile']['data']
        this.bungieName = this.getBungieName(info.userInfo)
        const characters = res['characters']['data']
        const dateLastPlayed = info['dateLastPlayed']
        info['characterIds'].forEach(id => {
          if (characters[id]['dateLastPlayed'] === dateLastPlayed) {
            this.character = characters[id]
            this.light = this.character['light']
          }
        })
        const metrics = res['metrics']['data']['metrics']
        for (const key in metrics) {
          const val = metrics[key]
          const progress = val['objectiveProgress']
          if (progress && this.metricsList.includes(progress['objectiveHash'])) {
            this.metrics.push({
              key: progress['objectiveHash'],
              value: progress['progress']
            })
          }
        }
      }).catch(err => {
        const correctType = err['MessageData']['membershipInfo.membershipType']
        this.getBungieInfo(params, correctType)
      })
    },
    getBungieName(info) {
      let bungieGlobalDisplayNameCode = info.bungieGlobalDisplayNameCode
      // bungieGlobalDisplayNameCode不够四位补足0
      if (bungieGlobalDisplayNameCode.length < 4) {
        bungieGlobalDisplayNameCode = bungieGlobalDisplayNameCode.padStart(4, '0')
      }
      return info.bungieGlobalDisplayName + '#' + bungieGlobalDisplayNameCode
    },
    getBungieImg(path) {
      if (path) {
        return `https://www.bungie.net${path.emblemPath}`
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>
.card-box{
  background-color: gray;
  margin: 5px 0;
  padding: 5px 20px;
}
</style>
